import dayjs from 'dayjs';

export const validatePickupTime = time => {
  if (time === '' || time === 'ASAP') {
    return true;
  }

  const difference = dayjs(time).diff(dayjs(), 'minutes');

  if (difference >= 14) {
    return true;
  }

  return false;
};

export const validateCateringPickupTime = time => {
  if (time === '' || !time) {
    return false;
  }

  // For catering orders, we just need to ensure a time is selected
  // The time doesn't need to be in the future since it's for a future date
  // The date validation handles ensuring the date is appropriate
  return true;
};
